import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/Button';
interface HeaderProps {
  lastRefreshed: Date;
  onRefresh: () => void;
  isRefreshing: boolean;
}
export function Header({
  lastRefreshed,
  onRefresh,
  isRefreshing
}: HeaderProps) {
  const timeString = lastRefreshed.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 py-6" data-id="element-106">
      <div data-id="element-107">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-108">
          Lead Ops Dashboard
        </h1>
        <p className="text-sm text-slate-500 mt-1" data-id="element-109">
          Monitor lead routing, campaign enrollment, and drip automation health.
        </p>
      </div>

      <div className="flex items-center gap-4" data-id="element-110">
        <div className="text-sm text-slate-500" title={lastRefreshed.toLocaleString()} data-id="element-111">
          Last refreshed:{' '}
          <span className="font-medium text-slate-700" data-id="element-112">{timeString}</span>
        </div>
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={isRefreshing} className="bg-white" data-id="element-113">
          <RefreshCw className={`w-4 h-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} data-id="element-114" />
          Refresh
        </Button>
      </div>
    </header>;
}